<app-portal-collapsible
    icon="login"
    title="Login & Passwort"
>
    @if (editMode) {
        <app-login-credentials-edit
            [customer]="customer()"
            (close)="toggleEditMode()"
            (customerChange)="updateCustomer($event)"
        />
    } @else {
        <app-login-credentials-display
            [customer]="customer()"
            (edit)="toggleEditMode()"
        />
    }
</app-portal-collapsible>
